import React, { useState } from 'react'
import type { FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import { useHistory } from 'react-router-dom'

import { Card, Snackbar } from '@homeviews/shared-ui'
import {
  SelectEmail,
  Typography,
  PageLayout,
  RequestsTable,
} from '@homeviews/outreach'

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      marginBottom: '40px',
    },
  }),
)

export const PageHome: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const [shownSuccess, setShownSuccess] = useState(false)

  const fromSuccess = () => {
    const tsState = history.location.state as Record<string, string>
    return tsState && tsState.from === 'success'
  }
  const onCloseSuccess = () => {
    setShownSuccess(true)
    history.push('outreach') // Clear .from state
  }

  return (
    <PageLayout>
      {fromSuccess() && (
        <Snackbar
          alertMessage="Emails have been sent"
          onClose={onCloseSuccess}
          open={!shownSuccess}
        />
      )}
      <Card className={classes.card}>
        <Typography variant="h2">Email Templates</Typography>
        <Typography variant="body1">
          Simply select an email template, upload resident emails, send and
          we&apos;ll invite your residents to take the HomeViews review
        </Typography>
        <SelectEmail
          templateSlug="new-tenant-email"
          title="New Resident Email"
        />
        <SelectEmail
          templateSlug="long-tenant-email"
          title="Current Resident Email"
        />
        <SelectEmail
          templateSlug="exit-tenant-email"
          title="Exit Resident Email"
        />
        <SelectEmail
          templateSlug="promotion-resident-email"
          title="Promotion Resident Email"
        />
      </Card>
      <RequestsTable />
    </PageLayout>
  )
}
